import Header from '../components/Header';
import { Outlet, useLocation } from 'react-router-dom';
import { PATHS } from '../routes/paths';

const NavTabLayout = () => {
  const location = useLocation();

  return (
    <>
      <div className='intelichat-conatiner-right'>
        <div className='chatbot-container'>
          <div className='chatbot-fixed header-responsive ps-md-5 ps-sm-4 ps-4 pe-md-5 pe-sm-4 pe-4'>
            <div className='d-block d-md-flex flex-wrap align-items-center justify-content-between'>
              <div className=''>
                {/* <h3 className='outfit-bold mb-0'>
                  {location.pathname === PATHS.CHATBOT
                    ? 'Train Your Agent'
                    : location.pathname === PATHS.LEAP
                    ? 'ComniqAI Leap'
                    : location.pathname === PATHS.DASHBOARD
                    ? 'Analytics'
                    : location.pathname === PATHS.INTEGRATIONS
                    ? 'Integrations App'
                    : location.pathname === PATHS.LEADS
                    ? 'My Leads'
                    : location.pathname === PATHS.PRICING
                    ? 'Pricing Plans'
                    : location.pathname === PATHS.SUBSCRIPTION_THANK_YOU
                    ? 'Pricing Plans'
                    : location.pathname === PATHS.USER_PROFILE
                    ? 'My Profile'
                    : location.pathname === PATHS.SETTINGS
                    ? 'Settings'
                    : 'Unknown Page'}
                </h3> */}
              </div>
              <div className='d-flex justify-content-end align-items-center responsive-header-width'>
                <Header />
              </div>
            </div>
          </div>
          <div className='chatbot-content'>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default NavTabLayout;
